module.exports = __webpack_public_path__ + "static/media/questionMarkGreen.8836cc2a.svg";